import CareersJobForm from "@components/BasicComponents/Forms/CareersJobForm/CareersJobForm"
import Iframe from "@components/CustomTypography/Iframe/Iframe"
import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import Separator from "@components/CustomTypography/Separator/Separator"
import Title from "@components/CustomTypography/Title/Title"
import ButtonComponent from "@components/Theme/Button/Button"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {getPosts} from "@config/modules"
import {JobModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import JobsDataSet from "@jsons/jobs.json"
import Error from "next/error"

import {JobComponentData} from "../../Blog/Post/PostComponent"
import PositionList from "../Positions/PositionTable/PositionList"

import styles from "./PositionPage.module.scss"

// TODO: Create Normal Template when we will get the design
const PositionPage = (props: {data: JobComponentData}) => {
	// Trow 404 page for unExist pages
	// ! Required for avoiding errors on server side rendering
	if (!props.data.post) {
		return <Error statusCode={404} />
	}

	let positionsData = getPosts("JobsModule", {data: JobsDataSet})

	const data = props.data.post

	positionsData = positionsData.filter(
		(element: JobModuleType) =>
			element.department[0].slug === data.department[0].slug,
	)

	if (typeof positionsData !== "undefined") {
		positionsData = positionsData.filter(
			(element: any) => element.slug !== data.slug,
		)
	}

	return (
		<div>
			<Separator>
				<Typography
					content={data.title}
					variant={Variant.SectionTitle}
					as={"h1"}
					center
				/>
				<Separator size={16} />
				<Typography
					content={
						<>
							{data.location[0].title}{" "}
							{data.responsibility && <>{data.responsibility}</>}
						</>
					}
					variant={Variant.Paragraph}
					center
				/>
			</Separator>
			<div className={styles.Iframe}>
				{data.preview.type === "image" && (
					<NewResponsiveImage
						{...data.preview}
						alt={props.data?.post.title ?? data.preview?.alt}
					/>
				)}
				{data.preview.type === "video" && (
					<Iframe {...props.data.post.preview} />
				)}
			</div>
			<Separator size={64} />
			<div className={styles.contentContainer}>
				<Typography
					content={data.content}
					variant={Variant.Description}
					as={"p"}
				/>
			</div>

			<Separator className={styles.formContainer} size={128}>
				<Title content={"Apply for this position"} />
				<Separator />
				<CareersJobForm
					location={props.data.post.location[0].title}
					position={props.data.post.title}
				/>
			</Separator>
			<Separator backgroundColor={"#F8FAFE"} type={"margin"}>
				<Separator className={styles.positionsList}>
					{positionsData.length > 0 && (
						<>
							<Typography
								style={{
									padding: "0 3rem 0 3rem",
								}}
								content={
									"Other positions that may interests you 	"
								}
								variant={Variant.SectionTitle}
							/>
							<Separator size={32} />
							<PositionList data={positionsData} />
						</>
					)}
					{positionsData.length <= 0 && (
						<>
							<Typography
								content={
									"Sorry, but currently we have no positions in similar field, but you can search for more positoins by link"
								}
								variant={Variant.SectionTitle}
							/>
							<Separator size={32} />
							<ButtonComponent
								buttonType={"primary"}
								link={"/careers"}
								asLink
							>
								Careers Page
							</ButtonComponent>
						</>
					)}
				</Separator>
			</Separator>
		</div>
	)
}

export default PositionPage
